import {
  TextField,
  useTranslate,
  FunctionField,
  useResourceContext
} from "react-admin";
import * as User from "providers/user";
import CustomList from "./CustomList";
import ListDotsActions from "./ListDotsActions";
import { Link } from "react-router-dom";
import { ListItemButton, Theme, useMediaQuery } from "@mui/material";
import CustomDataGrid from "./CustomDataGrid";
import { EmptyServiceIcon } from "assets/Icons";
import { CustomButton } from "./CustomButton";

export default function ServiceList() {
  const { user, permissions } = User.useUser();
  const translate = useTranslate();
  const resource = useResourceContext();
  const isAddOn = resource === "AddOns";
  const isSmall = useMediaQuery<Theme>("(max-width:800px)");

  const filter = {
    is_addon: isAddOn,
    company_id: permissions.isArtist
      ? user?.joined_company_id
      : permissions.companyId
  };

  return (
    <CustomList
      filter={filter}
      title={
        isAddOn
          ? translate("pagenames.addons")
          : translate("pagenames.services")
      }
      emptyIcon={<EmptyServiceIcon />}
      emptyTitle={
        isAddOn
          ? translate("empty_list.no_addons_yet")
          : translate("empty_list.no_services_yet")
      }
      createButtonText={
        isAddOn
          ? translate("empty_list.add_a_addon")
          : translate("empty_list.add_a_service")
      }
      emptyListCreateSubtitle={translate("empty_list.do_you_want_to_add_one")}
    >
      <CustomDataGrid bulkActionButtons={false} guideId="service-list-table">
        <TextField
          source="name"
          label={translate("services.name")}
          data-label={translate("services.name") + ":"}
          sx={{ marginTop: "6px" }}
        />
        <TextField
          source="category"
          label={translate("services.category")}
          data-label={translate("services.category") + ":"}
        />
        <FunctionField
          label={translate("services.price")}
          data-label={translate("services.price") + ":"}
          render={(record: any) => `$${record?.price}`}
        />
        <FunctionField
          label={translate("services.duration")}
          data-label={translate("services.duration") + ":"}
          render={(record: any) => (
            <div>
              {record?.duration >= 0 ? (
                <span>{`${record?.duration} mins`}</span>
              ) : (
                <span>-</span>
              )}
              {!!record?.clean_up_time &&
                !window.location.pathname.includes("AddOns") && (
                  <span title="Clean up time">{`+ (${record?.clean_up_time} mins)`}</span>
                )}
            </div>
          )}
        />
        {!isSmall && !permissions.isArtist && (
          <FunctionField
            render={(record: any) => (
              <ListDotsActions>
                <Link to={`/dashboard/${resource}/${record?.id}`}>
                  <ListItemButton
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Inter",
                      "& .MuiListItemButton-root": {
                        fontSize: "14px",
                        fontFamily: "Inter"
                      }
                    }}
                  >
                    {translate("common.edit")}
                  </ListItemButton>
                </Link>
              </ListDotsActions>
            )}
          />
        )}
        {isSmall && (
          <FunctionField
            render={(record: any) => (
              <Link
                to={`/dashboard/${resource}/${record?.id}/show`}
                style={{
                  width: "100%",
                  marginBottom: "10px"
                }}
              >
                <CustomButton
                  variant="secondary"
                  text={translate("common.view_details")}
                  sx={{ width: "100%" }}
                />
              </Link>
            )}
          />
        )}
      </CustomDataGrid>
    </CustomList>
  );
}
